import { toast } from "react-toastify";
import KogModalFadeComponent from "@/main/components/modal/ModalFadeComponent";
import { getTranslateByKey } from "@/main/services/utils";
import SecondaryButton from "@/main/components/shared/button/secondaryButton";
import Button from "@/main/components/shared/button/button";
import { quoteApi } from "@/main/api";
import { useCreateOrderContext } from "../../context";
import * as S from "./styles";
import { RoutesConstants } from "@/main/routes/routesConstants";
import { useNavigate } from "react-router-dom";

function ModalCancelQuotation() {
	const navigate = useNavigate();
	const { guidQuote, openModalCancel, setOpenModalCancel } = useCreateOrderContext();

	function handleCancel() {
		if (!guidQuote) return navigate(RoutesConstants.orderSearchOrder);
		quoteApi
			.cancelQuoteById({
				guid: guidQuote,
				route: RoutesConstants.orderCreateOrder,
			})
			.then(() => {
				toast.success(getTranslateByKey("information.successfullyCanceledOrder"));
				navigate(RoutesConstants.orderSearchOrder);
			});
	}
	return (
		<KogModalFadeComponent open={openModalCancel} setOpen={setOpenModalCancel}>
			<S.BoxModal>
				<S.TitleModal>{getTranslateByKey("information.areYouSureYouWantToCancelTheOrder")}</S.TitleModal>
				<div
					style={{
						display: "flex",
						justifyContent: "center",
						gap: "1rem",
					}}
				>
					<SecondaryButton type="button" onClick={() => setOpenModalCancel(false)}>
						{getTranslateByKey("information.no")}
					</SecondaryButton>
					<Button type="button" onClick={() => handleCancel()}>
						{getTranslateByKey("information.yes")}
					</Button>
				</div>
			</S.BoxModal>
		</KogModalFadeComponent>
	);
}

export default ModalCancelQuotation;
